import { render, staticRenderFns } from "./orderDetailProduct.vue?vue&type=template&id=14fdaf18"
import script from "./orderDetailProduct.vue?vue&type=script&lang=js"
export * from "./orderDetailProduct.vue?vue&type=script&lang=js"
import style0 from "./orderDetailProduct.vue?vue&type=style&index=0&id=14fdaf18&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fdaf18')) {
      api.createRecord('14fdaf18', component.options)
    } else {
      api.reload('14fdaf18', component.options)
    }
    module.hot.accept("./orderDetailProduct.vue?vue&type=template&id=14fdaf18", function () {
      api.rerender('14fdaf18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/components/orderDetailProduct.vue"
export default component.exports